import {
  SoopLayer,
  SoopLayerHeader,
  SoopLayerContent,
  useDialogContext,
  SoopLayerFooter,
} from '@soop-ui/soop-ui';
import styles from './CallInfoLayer.module.scss';

const CALL_NUMBER = '1688-7022';

interface CallInfoLayerProps {
  isMobile: boolean;
}

const CallInfoLayer = ({isMobile}: CallInfoLayerProps) => {
  const {close} = useDialogContext();
  const handleClose = () => {
    close(false);
  };

  return (
    <SoopLayer onClose={handleClose} size='lg'>
      <SoopLayerHeader align='left' className={styles.CallInfoHeader}>
        고객센터 대표 번호
      </SoopLayerHeader>
      <SoopLayerContent>
        <div className={styles.CallInfoWrapper}>
          <span className={styles.CallIco}></span>
          <div className={styles.CallInfoInner}>
            <a href={`tel:${CALL_NUMBER}`} className={styles.CallNumber}>
              {CALL_NUMBER}
            </a>
            <span className={styles.CallTime}>
              상담시간
              <br />
              평일 오전 9시~새벽 2시
            </span>
          </div>
        </div>
      </SoopLayerContent>
      {isMobile && <SoopLayerFooter onPrimaryClick={handleClose} />}
    </SoopLayer>
  );
};
export default CallInfoLayer;
